export const SettingsIcon: React.FC = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='18.383'
			height='18.384'
			className='settings-icon-svg'
			viewBox='0 0 18.383 18.384'>
			<path
				id='_004-settings'
				data-name='004-settings'
				d='M17.375,7.2l-1.44-.183A7.239,7.239,0,0,0,15.5,5.96l.889-1.145A1.139,1.139,0,0,0,16.295,3.3L15.089,2.093a1.142,1.142,0,0,0-1.52-.1l-1.144.889a7.213,7.213,0,0,0-1.053-.436l-.183-1.438A1.147,1.147,0,0,0,10.05,0H8.334A1.147,1.147,0,0,0,7.2,1.009l-.183,1.44a7.129,7.129,0,0,0-1.053.436L4.815,2A1.14,1.14,0,0,0,3.3,2.089L2.093,3.295A1.142,1.142,0,0,0,2,4.816L2.885,5.96a7.154,7.154,0,0,0-.436,1.052L1.011,7.2A1.147,1.147,0,0,0,0,8.334V10.05a1.147,1.147,0,0,0,1.009,1.138l1.44.183a7.239,7.239,0,0,0,.436,1.052L2,13.569a1.139,1.139,0,0,0,.093,1.516L3.3,16.291a1.143,1.143,0,0,0,1.52.1L5.96,15.5a7.072,7.072,0,0,0,1.052.436L7.2,17.371a1.147,1.147,0,0,0,1.138,1.013H10.05a1.147,1.147,0,0,0,1.138-1.009l.183-1.44a7.239,7.239,0,0,0,1.052-.436l1.145.889a1.139,1.139,0,0,0,1.516-.093l1.206-1.206a1.141,1.141,0,0,0,.1-1.52L15.5,12.424a7.072,7.072,0,0,0,.436-1.052l1.437-.183a1.147,1.147,0,0,0,1.011-1.138V8.334A1.146,1.146,0,0,0,17.375,7.2ZM9.192,13.022a3.83,3.83,0,1,1,3.83-3.83A3.834,3.834,0,0,1,9.192,13.022Z'
				fill='#3b2a82'
			/>
		</svg>
	)
}
